import React from "react"

export const SvgOpen = ({ className }: { className?: string }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3333 5H5V23.6667C5 24.3739 5.28095 25.0522 5.78105 25.5523C6.28115 26.0524 6.95942 26.3333 7.66667 26.3333H23.6667C24.3739 26.3333 25.0522 26.0524 25.5523 25.5523C26.0524 25.0522 26.3333 24.3739 26.3333 23.6667V17M11.6667 19.6667L26.3333 5M26.3333 5H19.6667M26.3333 5V11.6667"
      stroke="#A1AFBF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    />
    <path
      d="M14.3333 5H5V23.6667C5 24.3739 5.28095 25.0522 5.78105 25.5523C6.28115 26.0524 6.95942 26.3333 7.66667 26.3333H23.6667C24.3739 26.3333 25.0522 26.0524 25.5523 25.5523C26.0524 25.0522 26.3333 24.3739 26.3333 23.6667V17M11.6667 19.6667L26.3333 5M26.3333 5H19.6667M26.3333 5V11.6667"
      stroke="#8B8B8B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
